
import React from 'react';
import { DialogHeader as UIDialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface DialogHeaderProps {
  title: string;
  onClose: () => void;
}

const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  onClose
}) => {
  return (
    <UIDialogHeader>
      <DialogTitle>{title}</DialogTitle>
      <Button 
        variant="ghost" 
        size="icon" 
        className="absolute right-4 top-4" 
        onClick={onClose}
      >
        <X className="h-4 w-4" />
      </Button>
    </UIDialogHeader>
  );
};

export default DialogHeader;
